// extracted by mini-css-extract-plugin
module.exports = {"option":"sBY-r","name":"RWnl7"};